var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"reports-table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])})})],2),_c('tbody',_vm._l((_vm.data),function(item,rowIdx){return _c('tr',{key:rowIdx},_vm._l((_vm.columns),function(column,colIdx){return _c('td',{key:colIdx,class:{
      'has-error': _vm.hasError(item, column)
    }},[_vm._v(" "+_vm._s(_vm.getCellValue(item, column))+" ")])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }